module.exports = __webpack_public_path__ + "img/hx-logo.398a7ef0.png";